var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwipeleftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 92"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 14",
    cx: 19.5,
    cy: 19.5,
    r: 17.5,
    transform: "rotate(180 19.5 19.5)",
    fill: "#0D99FF",
    stroke: "#0D99FF",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.001 18.7911C13.009 19.1412 13.143 19.4758 13.3771 19.7301L21.6296 28.5682C21.8835 28.8379 22.2311 28.9931 22.5961 28.9998C22.9611 29.0065 23.3139 28.8641 23.577 28.6038C23.84 28.3435 23.9921 27.9867 23.9997 27.6114C24.0072 27.2361 23.8698 26.873 23.6174 26.6017L16.2784 18.7469L23.6174 10.892C23.8698 10.6207 24.0072 10.2577 23.9997 9.88239C23.9921 9.50711 23.84 9.15022 23.577 8.88997C23.3139 8.62971 22.9611 8.48731 22.5961 8.49399C22.2311 8.50067 21.8835 8.65587 21.6296 8.92559L13.3771 17.7637C13.251 17.9005 13.1527 18.0619 13.0881 18.2383C13.0236 18.4148 12.9939 18.6027 13.001 18.7911Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwipeleftIcon);
export default __webpack_public_path__ + "static/media/swipeleftIcon.8593e5d128e7fdd0d50ccaa336a74c45.svg";
export { ForwardRef as ReactComponent };